const basePath = 'dvps';

export const apiConstant: any = {
  ME: basePath+'/me',
  PHYSICAL_SEC: basePath+'/physicalsecurities',
  CUST_AUDITOR: basePath+'/auditor',
  CREATE_TXN: basePath+'/external/physicalsecurity',
  DOC_UPLOAD: basePath+'/document/upload',
  LOGIN: 'api/auth/login',
  LOGIN_SAML: 'auth/saml',
  ASSIGN_AUDITOR: basePath+'/auditor/assign',
  UPDATE_AUDITOR: basePath+'/auditor/update',
  SEC_MASTER: basePath+'/skeletonSecurities',
  SEC_MASTER_FILTER_VALUES: basePath +'/skeletonSecurity/uniqueFilters',
  PEERS: basePath+'/peers',
  DOC_OPEN_INDICATOR: basePath+'/document/open-indicator',
  DOC_APPROVE: basePath+'/document/buy/approve',
  DOC_REJECT: basePath+'/document/buy/reject',
  DOC_OPEN: basePath+'/document/download',
  SHARE_TXN: basePath+'/share/auditor',
  GET_SELL_CERTIFICATES: basePath+'/sellCeritificates',
  POST_SELL_CERTIFICATES: basePath+'/physicalsecurity/sell',
  APPROVE_SELL_CERTIFICATE: basePath+'/document/sell/approve',
  REJECT_SELL_CERTIFICATE: basePath+'/document/sell/reject',
  HOLIDINGS: basePath+'/holdings/',
  HOLIDINGS_CERTIFICATES: basePath+'/holdings/holdingCertificates',
  DASHBOARD_SUMMARY: basePath+'/physicalSecurities/transactionsSummary',
  GET_DOCUMENTS: basePath + '/document/',
  CREATE_SECURITY: basePath + '/external/skeletonSecurity',
  CREATE_HOLDINGS: basePath + '/external/holdings',
  PPN_APPROVE: basePath+'/skeletonSecurity/APPROVED',
  PPN_REJECT: basePath+'/skeletonSecurity/REJECTED',
  TXN_FILTER_VALUES: basePath +'/physicalsecurities/uniqueFilters',
  HOLDINGS_FILTER_VALUES: basePath +'/holdings/uniqueFilters',
  MISSED_TRANSACTIONS: basePath + '/physicalSecurities/missedTradesInDV',
  MISSED_SECURITIES: basePath + '/skeletonSecurity/missedSecuritiesInDV',
  MISSED_HOLDINGS: basePath + '/holdings/missedHoldingsInDV',
  CREATE_CLIENT_IDS: basePath + '/client/create',
  GET_CLIENT_IDS: basePath + '/client/findall',
  UPDATE_CLIENT_IDS: basePath + '/client/update',
  DELETE_CLIENT_IDS: basePath + '/client/delete',
  // CREATE_ACCOUNT_NUM: basePath + '/accNumber/create',
  // GET_ACCOUNT_NUM: basePath + '/accNumber/findall',
  // UPDATE_ACCOUNT_NUM: basePath + '/accNumber/update',
  // DELETE_ACCOUNT_NUM: basePath + '/accNumber/delete',
  CREATE_RPC_USER: basePath + '/rpcuser/create',
  CREATE_APP_USER: basePath + '/appUser/create',
  GET_RPC_USER: basePath + '/rpcuser/findall',
  GET_APP_USER: basePath + '/appUser/findall',
  UPDATE_RPC_USER: basePath + '/rpcuser/update',
  UPDATE_APP_USER: basePath + '/appUser/update',
  DELETE_RPC_USER: basePath + '/rpcuser/delete',
  DELETE_APP_USER: basePath + '/appUser/delete',
  API_VERSION: basePath + '/apiversion',
  API_CORDA_VERSION: basePath + '/apicordaversion',
  LOGOUT: basePath + '/logout',
  HOLIDINGS_EXPORT: basePath+'/holdings/download',
};

export const backendPagination = true;
export const rowsPerPage = 10;
export const tableAutoLayout = true;
//export const useEnvHost = true;
export const authCookieName = 'DVSESSIONID';

export const documentTypes = [
  {name: 'Certificate', code: 'CERTIFICATE'},
  {name: 'Supplementary', code: 'SUPPLEMENTARY'},
  {name: 'Checklist', code: 'CHECKLIST'}
];

export const documentUsages = [
  {name: 'External', code: 'EXTERNAL'},
  {name: 'Internal', code: 'INTERNAL'}
];

export const documentUsageVal = {
  'EXTERNAL': 'EXTERNAL',
  'INTERNAL': 'INTERNAL'
};

export const documentConstants = {
  "INTERNAL": "Internal",
  "EXTERNAL": "External",
  "CERTIFICATE": "Certificate",
  "SUPPLEMENTARY": "Supplementary",
  "CHECKLIST": "Checklist",
  'APPROVED': 'Approved',
  'REJECTED': 'Rejected',
  'UPLOADED': 'Uploaded',
  'REMOVED': 'Removed',
  'NOT-UPLOADED': 'Not uploaded',
  'NA': 'NA',
  'SOLD': 'Sold',
  'TOBESOLD': 'To be sold',
  'VERIFIED': 'Verified',
  'NON-UPLOADED': 'Not uploaded'
};

export const transactionStatus = {
  'NOT_UPLOADED': 'NON-UPLOADED',
  'UPLOADED': 'UPLOADED',
  'VERIFIED': 'VERIFIED',
  'TOBESOLD': 'TOBESOLD',
  'SOLD': 'SOLD',
  'PENDING_SELL': 'PENDING_SELL',
  'PENDING_SELL_APPROVAL': 'PENDING_SELL_APPROVAL',
  'PARTIALLY_SOLD': 'PARTIALLY_SOLD'
};

export const documentStatus = {
  'APPROVED': 'APPROVED',
  'REJECTED': 'REJECTED',
  'UPLOADED': 'UPLOADED',
  'TOBEREMOVED': 'TOBEREMOVED',
  'REMOVED': 'REMOVED',
  'DOCUMENT_OPENED': 'DOCUMENT_OPENED',
  'INTERNAL_DOC': 'INTERNAL_DOC',
  'SOLD': 'SOLD',
  'TOBESOLD': 'TOBESOLD'
};

export const transactionTypesConst = {
  'BUY': 'BUY',
  'SELL': 'SELL'
}

export const auditorList = [
  {name: 'KPMG', code: 'KPMG'},
  {name: 'Deloitte', code: 'Deloitte'}
];

export const nodeTypes = {
  //'CUSTOMER': 'CUSTOMER',
  //'BACK_OFFICE': 'SYSTEM',
  //'HSS': 'HSSOPS',
  //'AUDITOR': 'AUDITOR',
  //'REGULATOR': 'REGULATOR',
  //'ADMIN': 'ADMIN'
  'CUSTOMER': 'ROLE_CUSTOMER',
  'BACK_OFFICE': 'ROLE_CDW',
  'HSS': 'ROLE_OPS_USER',
  'AUDITOR': 'ROLE_AUDITOR',
  'REGULATOR': 'ROLE_REGULATOR',
  'ADMIN': 'ROLE_ADMIN'
}

export const transactionTypes = [
  {name: 'Buy', code: 'BUY'},
  {name: 'Sell', code: 'SELL'}
];
/* export const transactionTypes = [
  {name: 'Receive free of payment', code: 'RECEIVE FREE PAYMENT'},
  {name: 'Receive against payment', code: 'RECEIVE AGAINST PAYMENT'},
  {name: 'Deliver free of payment', code: 'DELIVER FREE PAYMENT'},
  {name: 'Deliver against payment', code: 'DELIVER AGAINST PAYMENT'},
  {name: 'Deposit', code: 'DEPOSIT'},
  {name: 'Withdrawal', code: 'WITHDRAWAL'},
  {name: 'Reversal of receive free of payment', code: 'REVERSAL OF RECEIVE FREE PAYMT'},
  {name: 'Reversal of receive against payment', code: 'REVERSAL OF RECEIVE AGST PAYMT'},
  {name: 'Reversal of deliver free of payment', code: 'REVERSAL OF DELIVER FREE PAYMT'},
  {name: 'Reversal of deliver against payment', code: 'REVERSAL OF DELIVER AGST PAYMT'}
]; */

export const txnTypesCategory = {
  "BUY": ['RECEIVE FREE PAYMENT', 'RECEIVE AGAINST PAYMENT', 'DEPOSIT', 'REVERSAL OF DELIVER FREE PAYMT', 'REVERSAL OF DELIVER AGST PAYMT'],
  "SELL": ['DELIVER FREE PAYMENT', 'DELIVER AGAINST PAYMENT', 'WITHDRAWAL', 'REVERSAL OF RECEIVE FREE PAYMT', 'REVERSAL OF RECEIVE AGST PAYMT']
};

export const txnTableColumns = {
  'CLIENT': 'Client',
  'ACCOUNT': 'Account Number',
  // 'ISSUER': 'Issuer',
  'SECURITY_ID': 'Security ID',
  'PPN': 'PPN',
  'DESCRIPTION': 'Security Description',
  'HSS_TXN_ID': 'HSBC Reference',
  // 'DV_TXN_ID': 'DV trade ID',
  'TXN_DATE': 'Trade date',
  'AMOUNT_QUANTITY': 'Quantity',
  'CURRENCY': 'Settlement Currency',
  'LOCATION': 'Location Code',
  'ISIN': 'ISIN',
  'CUSIP': 'CUSIP',
  'SEDOL': 'SEDOL',
  'TXN_TYPE': 'Txn type',
  'TXN_STATUS': 'Txn status',
  'CLIENT_ID': 'Client ID',
  'CDW_JOB_RUN_DATE': 'CDW job run date',
  'CDW_TXN_LAST_UPDATED_DATE': 'CDW txn updated time',
  'LOCAL_SECURITY_ID': 'HSBC Security ID',
  'SECURITY_TYPE': 'Security type',
  'SECURITY_QTY_TYPE': 'Quantity Type',
  'TRADED_MARKET': 'Traded market',
};

export const columnsHoverText = {
  'CLIENT': 'Client name',
  'ACCOUNT': 'Account number',
  'ISSUER': 'Issuer name',
  'SECURITY_ID': 'Security ID',
  'PPN': 'Private placement number',
  'DESCRIPTION': 'Description',
  'HSS_TXN_ID': 'HSBC transaction ID',
  // 'DV_TXN_ID': 'Digital vault trade ID',
  'TXN_DATE': 'Trade date',
  'AMOUNT_QUANTITY': 'Face amount/quantity',
  'CURRENCY': 'Currency',
  'LOCATION': 'Location',
  'ISIN': 'ISIN',
  'CUSIP': 'CUSIP',
  'SEDOL': 'SEDOL',
  'LOCAL_SECURITY_ID': 'Local security ID',
  'SECURITY_TYPE': 'Security type',
  'SECURITY_QTY_TYPE': 'Security quantity type',
  'TRADED_MARKET': 'Traded market'
};

export const txnTableFields = {
  'CLIENT': 'customerName',
  'ACCOUNT': 'accNumber',
  // 'ISSUER': 'issuer',
  'SECURITY_ID': 'isin',
  'PPN': 'ppn',
  'DESCRIPTION': 'stockDescription',
  'HSS_TXN_ID': 'backOfficeId',
  'DV_TXN_ID': 'linearId',
  'TXN_DATE': 'txnDate',
  'AMOUNT_QUANTITY': 'transactionFaceAmount',
  'CURRENCY': 'currency',
  'CCY': 'ccy',
  'LOCATION': 'locationDesc',
  'LOCAL_SECURITY_ID': 'localSecurityId'
};

export const holdingsTableColumns = {
  'AMOUNT_QUANTITY': 'Settled Aggregate Value',
  'CURRENCY': 'Currency'
};

export const securitiesTableFields = {
  'SECURITY_TYPE': 'securityType',
  'SECURITY_QTY_TYPE': 'securityQtyType',
  'TRADED_MARKET': 'tradedMarket'
};

export const docTableColumns = {
  'DOCUMENT_STATUS': 'Document status',
  'DOCUMENT_NAME': 'Document name',
  'DOCUMENT_TYPE': 'Document type',
  'USAGE': 'Usage',
  'CERTIFICATE_NO': 'Certificate no.',
  'AMOUNT_QUANTITY': 'Amount/qty',
  'DOCUMENT_HASH': 'Document hash',
  'UPLOAD_DATE': 'Upload date',
  'UPLOADED_BY': 'Uploaded by',
  'VERIFICATION_DATE': 'Verification date',
  'VERIFIED_BY': 'Verified by',
  'SELL_INITIATION_DATE': 'Sell initiation date',
  'SELL_INITIATED_BY': 'Sell initiated by',
  'SELL_VERIFICATION_DATE': 'Sell verification date',
  'SELL_VERIFIED_BY': 'Sell verified by'
};

export const secMasterTableColumns = {
  'SECURITY_ID': 'Security ID',
  'LOCAL_SECURITY_ID': 'HSBC Security ID',
  'PPN': 'PPN',
  'CCY': 'Currency',
  'SECURITY_TYPE': 'Security type',
  'SECURITY_QTY_TYPE': 'Quantity Type',
  'TRADED_MARKET': 'Traded market',
  'ISSUER': 'Issuer',
  'DESCRIPTION': 'Security Description',
  'ISIN': 'ISIN',
  'CUSIP': 'CUSIP',
  'SEDOL': 'SEDOL'
};

export const opsTxnCols = [
  { field: 'customerName', header: txnTableColumns.CLIENT, hoverText: columnsHoverText.CLIENT },
  { field: 'accNumber', header: txnTableColumns.ACCOUNT, hoverText: columnsHoverText.ACCOUNT },
  // { field: 'issuer', header: txnTableColumns.ISSUER, hoverText: columnsHoverText.ISSUER },
  { field: 'isin', header: txnTableColumns.SECURITY_ID, hoverText: columnsHoverText.SECURITY_ID },
  { field: 'ppn', header: txnTableColumns.PPN, hoverText: columnsHoverText.PPN },
  { field: 'stockDescription', header: txnTableColumns.DESCRIPTION, hoverText: columnsHoverText.DESCRIPTION },
  { field: 'backOfficeId', header: txnTableColumns.HSS_TXN_ID, hoverText: columnsHoverText.HSS_TXN_ID },
  // { field: 'linearId.id', header: txnTableColumns.DV_TXN_ID, hoverText: columnsHoverText.DV_TXN_ID },
  { field: 'formatedTxnDate', header: txnTableColumns.TXN_DATE, hoverText: columnsHoverText.TXN_DATE},
  { field: 'transactionFaceAmount', header: txnTableColumns.AMOUNT_QUANTITY, hoverText: columnsHoverText.AMOUNT_QUANTITY },
  { field: 'ccy', header: txnTableColumns.CURRENCY, hoverText: columnsHoverText.CURRENCY },
  { field: 'locationDesc', header: txnTableColumns.LOCATION, hoverText: columnsHoverText.LOCATION }
];

export const customerTxnCols = [
  { field: 'accNumber', header: txnTableColumns.ACCOUNT, hoverText: columnsHoverText.ACCOUNT },
  // { field: 'issuer', header: txnTableColumns.ISSUER, hoverText: columnsHoverText.ISSUER },
  { field: 'isin', header: txnTableColumns.SECURITY_ID, hoverText: columnsHoverText.SECURITY_ID },
  { field: 'ppn', header: txnTableColumns.PPN, hoverText: columnsHoverText.PPN },
  { field: 'stockDescription', header: txnTableColumns.DESCRIPTION, hoverText: columnsHoverText.DESCRIPTION },
  { field: 'backOfficeId', header: txnTableColumns.HSS_TXN_ID, hoverText: columnsHoverText.HSS_TXN_ID },
  // { field: 'linearId.id', header: txnTableColumns.DV_TXN_ID, hoverText: columnsHoverText.DV_TXN_ID },
  { field: 'formatedTxnDate', header: txnTableColumns.TXN_DATE, hoverText: columnsHoverText.TXN_DATE },
  { field: 'faceAmount', header: txnTableColumns.AMOUNT_QUANTITY, hoverText: columnsHoverText.AMOUNT_QUANTITY },
  { field: 'ccy', header: txnTableColumns.CURRENCY, hoverText: columnsHoverText.CURRENCY },
  { field: 'locationDesc', header: txnTableColumns.LOCATION, hoverText: columnsHoverText.LOCATION }
];

export const secMasterCols = [
  { field: 'isin', header: secMasterTableColumns.SECURITY_ID, hoverText: columnsHoverText.SECURITY_ID },
  { field: 'localSecurityId', header: secMasterTableColumns.LOCAL_SECURITY_ID, hoverText: columnsHoverText.LOCAL_SECURITY_ID },
  { field: 'issuer', header: secMasterTableColumns.ISSUER, hoverText: columnsHoverText.ISSUER },
  { field: 'stockDescription', header: secMasterTableColumns.DESCRIPTION, hoverText: columnsHoverText.DESCRIPTION },
  { field: 'ppn', header: secMasterTableColumns.PPN, hoverText: columnsHoverText.PPN },
  { field: 'ccy', header: secMasterTableColumns.CCY, hoverText: columnsHoverText.CURRENCY },
  { field: 'securityType', header: secMasterTableColumns.SECURITY_TYPE, hoverText: columnsHoverText.SECURITY_TYPE },
  { field: 'securityQtyType', header: secMasterTableColumns.SECURITY_QTY_TYPE, hoverText: columnsHoverText.SECURITY_QTY_TYPE },
  { field: 'tradedMarket', header: secMasterTableColumns.TRADED_MARKET, hoverText: columnsHoverText.TRADED_MARKET }
];

export const customerHoldingsCols = [
  { field: 'accNumber', header: txnTableColumns.ACCOUNT, hoverText: columnsHoverText.ACCOUNT },
  // { field: 'issuer', header: txnTableColumns.ISSUER, hoverText: columnsHoverText.ISSUER },
  { field: 'isin', header: txnTableColumns.SECURITY_ID, hoverText: columnsHoverText.SECURITY_ID },
  { field: 'ppn', header: txnTableColumns.PPN, hoverText: columnsHoverText.PPN },
  { field: 'stockDescription', header: txnTableColumns.DESCRIPTION, hoverText: columnsHoverText.DESCRIPTION },
  { field: 'holdingAmount', header: holdingsTableColumns.AMOUNT_QUANTITY, hoverText: columnsHoverText.AMOUNT_QUANTITY },
  { field: 'ccy', header: holdingsTableColumns.CURRENCY, hoverText: columnsHoverText.CURRENCY },
  { field: 'locationDesc', header: txnTableColumns.LOCATION, hoverText: columnsHoverText.LOCATION }
];

export const appLabels = {
  BUY_TRANSACTIONS: 'Buy transactions',
  SELL_TRANSACTIONS: 'Sell transactions',
  SEC_MASTER: 'Security master',
  HOLDINGS: 'Holdings',
  HELP: 'Help'
};

export const mimeTypes = {
  "evy": "application/envoy",
  "fif": "application/fractals",
  "spl": "application/futuresplash",
  "hta": "application/hta",
  "acx": "application/internet-property-stream",
  "hqx": "application/mac-binhex40",
  "doc": "application/msword",
  "dot": "application/msword",
  "*": "application/octet-stream",
  "bin": "application/octet-stream",
  "class": "application/octet-stream",
  "dms": "application/octet-stream",
  "exe": "application/octet-stream",
  "lha": "application/octet-stream",
  "lzh": "application/octet-stream",
  "oda": "application/oda",
  "axs": "application/olescript",
  "pdf": "application/pdf",
  "prf": "application/pics-rules",
  "p10": "application/pkcs10",
  "crl": "application/pkix-crl",
  "ai": "application/postscript",
  "eps": "application/postscript",
  "ps": "application/postscript",
  "rtf": "application/rtf",
  "setpay": "application/set-payment-initiation",
  "setreg": "application/set-registration-initiation",
  "xla": "application/vnd.ms-excel",
  "xlc": "application/vnd.ms-excel",
  "xlm": "application/vnd.ms-excel",
  "xls": "application/vnd.ms-excel",
  "xlt": "application/vnd.ms-excel",
  "xlw": "application/vnd.ms-excel",
  "msg": "application/vnd.ms-outlook",
  "sst": "application/vnd.ms-pkicertstore",
  "cat": "application/vnd.ms-pkiseccat",
  "stl": "application/vnd.ms-pkistl",
  "pot": "application/vnd.ms-powerpoint",
  "pps": "application/vnd.ms-powerpoint",
  "ppt": "application/vnd.ms-powerpoint",
  "mpp": "application/vnd.ms-project",
  "wcm": "application/vnd.ms-works",
  "wdb": "application/vnd.ms-works",
  "wks": "application/vnd.ms-works",
  "wps": "application/vnd.ms-works",
  "hlp": "application/winhlp",
  "bcpio": "application/x-bcpio",
  "cdf": "application/x-cdf",
  "z": "application/x-compress",
  "tgz": "application/x-compressed",
  "cpio": "application/x-cpio",
  "csh": "application/x-csh",
  "dcr": "application/x-director",
  "dir": "application/x-director",
  "dxr": "application/x-director",
  "dvi": "application/x-dvi",
  "gtar": "application/x-gtar",
  "gz": "application/x-gzip",
  "hdf": "application/x-hdf",
  "ins": "application/x-internet-signup",
  "isp": "application/x-internet-signup",
  "iii": "application/x-iphone",
  "js": "application/x-javascript",
  "latex": "application/x-latex",
  "mdb": "application/x-msaccess",
  "crd": "application/x-mscardfile",
  "clp": "application/x-msclip",
  "dll": "application/x-msdownload",
  "m13": "application/x-msmediaview",
  "m14": "application/x-msmediaview",
  "mvb": "application/x-msmediaview",
  "wmf": "application/x-msmetafile",
  "mny": "application/x-msmoney",
  "pub": "application/x-mspublisher",
  "scd": "application/x-msschedule",
  "trm": "application/x-msterminal",
  "wri": "application/x-mswrite",
  "nc": "application/x-netcdf",
  "pma": "application/x-perfmon",
  "pmc": "application/x-perfmon",
  "pml": "application/x-perfmon",
  "pmr": "application/x-perfmon",
  "pmw": "application/x-perfmon",
  "p12": "application/x-pkcs12",
  "pfx": "application/x-pkcs12",
  "p7b": "application/x-pkcs7-certificates",
  "spc": "application/x-pkcs7-certificates",
  "p7r": "application/x-pkcs7-certreqresp",
  "p7c": "application/x-pkcs7-mime",
  "p7m": "application/x-pkcs7-mime",
  "p7s": "application/x-pkcs7-signature",
  "sh": "application/x-sh",
  "shar": "application/x-shar",
  "swf": "application/x-shockwave-flash",
  "sit": "application/x-stuffit",
  "sv4cpio": "application/x-sv4cpio",
  "sv4crc": "application/x-sv4crc",
  "tar": "application/x-tar",
  "tcl": "application/x-tcl",
  "tex": "application/x-tex",
  "texi": "application/x-texinfo",
  "texinfo": "application/x-texinfo",
  "roff": "application/x-troff",
  "t": "application/x-troff",
  "tr": "application/x-troff",
  "man": "application/x-troff-man",
  "me": "application/x-troff-me",
  "ms": "application/x-troff-ms",
  "ustar": "application/x-ustar",
  "src": "application/x-wais-source",
  "cer": "application/x-x509-ca-cert",
  "crt": "application/x-x509-ca-cert",
  "der": "application/x-x509-ca-cert",
  "pko": "application/ynd.ms-pkipko",
  "zip": "application/zip",
};
